import {
  SimpleForm,
  TextInput,
  required,
  email,
  SelectInput,
  BooleanInput,
  NumberInput,
} from 'react-admin';
import { RolesMap, UserRoles } from '../../../shared/types/User';

// id uuid PRIMARY KEY DEFAULT uuid_generate_v4(),
// first_name VARCHAR(255) NOT NULL DEFAULT '',
// last_name VARCHAR(255) NOT NULL DEFAULT '',
// email VARCHAR(255) NOT NULL UNIQUE,
// -- phone VARCHAR(255) NOT NULL UNIQUE,
// -- username VARCHAR(255) NOT NULL UNIQUE,
// password VARCHAR(255) NOT NULL,
// country VARCHAR(255) NOT NULL DEFAULT '',
// city VARCHAR(255) NOT NULL DEFAULT '',
// description TEXT NOT NULL DEFAULT '',
// is_married VARCHAR(1) NOT NULL DEFAULT '',

export const ChangeUserForm = () => (
  <SimpleForm>
    <TextInput
      source="firstName"
      fullWidth
      label="Имя"
      validate={[required('Обязательно для заполнения')]}
    />
    <TextInput
      source="lastName"
      fullWidth
      label="Фамилия"
      validate={[required('Обязательно для заполнения')]}
    />
    <TextInput
      source="email"
      fullWidth
      label="E-mail"
      validate={[
        // required('Обязательно для заполнения'),
        email('Укажите корректный E-mail'),
      ]}
    />
    <TextInput
      source="description"
      fullWidth
      label="Описание"
      // validate={[required('Обязательно для заполнения')]}
    />
    <BooleanInput source="is_onboarding_done" label="Завершен ли онбординг" />

    <NumberInput source="onboarding_step" label="Шаг онбординга" />

    <TextInput source="occupation" label="Профессия" />

    <TextInput source="type_of_personality" label="тип личности (4)" />
  </SimpleForm>
);
